import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// The Simplest Store
export default new Vuex.Store({
  state: {
    loggedIn: localStorage.getItem("loggedIn") === 'true',
    afterLoginPath: "/",
    //profile_data: null,
    user_name: null
  },
  mutations: {
    login (state, status){
      state.loggedIn = status
    },
    setAfterLoginPath (state, path){
      if (path != "/forgot_password" && path != "/resend_confirmation") {
        state.afterLoginPath = path
      }
    },
  //  setProfileData(state, profile_obj){
  //    state.profile_data = JSON.stringify(profile_obj)
  //  },
    setUserName(state, name){
      state.user_name = name
    }
  },
  getters:{
    loginStatus: state =>{
      return state.loggedIn
    },
    getAfterLoginPath: state => {
      return state.afterLoginPath
    },
    //getProfileData: state => {
    //  return JSON.parse(state.profile_data)
    //},
    getUserName: state => {
      return state.user_name
    }
  }
})
